/**
 * @fileoverview POST handler for the "/app_groups/:app_group_id/placements" endpoint
 */
import fetch from "@lib/fetch";

import { buildPlacementTargetingBody } from "@dashboardApi/apis/placementsShared";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsCacheKeys } from "./constants";
import type { PostAppGroupsAppGroupIdPlacementsProps, PostAppGroupsAppGroupIdPlacementsResult } from "./types";

export const postAppGroupsAppGroupIdPlacements = reactQueryMutationAdapter(
  appGroupsAppGroupIdPlacementsCacheKeys,
  ({
    placementId,
    name,
    description,
    appGroupId,
    targeting,
  }: PostAppGroupsAppGroupIdPlacementsProps): Promise<PostAppGroupsAppGroupIdPlacementsResult> => {
    const targetingBody = buildPlacementTargetingBody(targeting);

    return fetch(
      `/app_groups/${appGroupId}/placements`,
      "POST",
      {
        placement_id: placementId,
        name,
        description,
        targeting: targetingBody,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
